import { render, staticRenderFns } from "./richTextAndPreview.vue?vue&type=template&id=a9527b98&"
import script from "./richTextAndPreview.vue?vue&type=script&lang=js&"
export * from "./richTextAndPreview.vue?vue&type=script&lang=js&"
import style0 from "./richTextAndPreview.vue?vue&type=style&index=0&id=a9527b98&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports